/* eslint-disable react-hooks/exhaustive-deps */
import DataGridColumn from "./DataGridColumn";
import { FlexGridCellTemplate } from "@grapecity/wijmo.react.grid";
import { useEffect, useState } from "react";

import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
// Form Item Type Select에 대응하는 Custom DataGridColumn

function DataGridFileDownloadColumn ( props ) {

    const { schema, ...others } = props;

    const [ cellTemplate, setCellTemplate ] = useState ( ( ctx ) => {
        return <></>;
    } );

    useEffect ( () => {

        setCellTemplate ( () => ( ( ctx ) => {
            
            if ( ctx.item[schema.name] && ctx.item[schema.name][0] === '/') {

                return (
                    <>

                        <span onClick={() =>
                                ( process.env.NODE_ENV === 'production' )
                                ?
                                window.open(`${ctx.item[schema.name]}`)
                                :
                                window.open(`http://localhost:8080${ctx.item[schema.name]}`)}>
                                

                            <IconButton size="small" sx={{p: 0, m: 0}}>

                                <Icon>download</Icon>

                            </IconButton>

                        </span>

                    </>
                );

            }

        } ) );

    }, [schema] );

    return (

        <DataGridColumn schema={schema} align="center" {...others} >
            <FlexGridCellTemplate cellType="Cell" template={cellTemplate} />
        </DataGridColumn>

    );

}

export default DataGridFileDownloadColumn;

